import { mdiCalendarClock } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/components/administration"
import type { OrgaViewFrameContext } from "../../../../context"
import { canViewOrganizationSettings } from "../../../../_shared/_logic/access"

export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "planning",
  title: "Terminplanung",
  tooltip:
    "Planungsvorlauf, Zeitfenster, Terminpuffer und den Zeitpunkt der Terminbrief-Aufgaben festlegen.",
  icon: mdiCalendarClock,
  routeSegment: "planning",
  getPages: (context) =>
    canViewOrganizationSettings(context)
      ? [
          {
            id: "planning",
            title: "Terminplanung",
            path: "",
            widthType: "normal",
            testId: "controlAdmin.organizationView.tab.planning",
          },
        ]
      : [],
}
